import PropTypes from 'prop-types'
import React from 'react'
import { Tooltip } from '@mui/material'

const ColorOval = ({
    className = '',
    onClick = () => {},
    label = '',
    color = 'red',
    tooltip = null,
}) => {
    return (
        <Tooltip title={tooltip}>
            <span onClick={onClick} className={className}>
                <span className={'arrests-level-panel'} style={ { color, backgroundColor: color } }>__</span>
                {label}
            </span>
        </Tooltip>
    )
}

ColorOval.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.string,
    color: PropTypes.string,
    tooltip: PropTypes.string,
}

ColorOval.defaultProps = {
    className: '',
    label: '',
    color: 'red',
    tooltip: null,
}

export default ColorOval
